import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";

/**
 * Hook para detectar si la sesión ha sido cerrada desde otro dispositivo
 * Verifica cada 30 segundos si la sesión sigue siendo válida
 */
export const useSessionValidator = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!authService.isAuthenticated()) {
      return;
    }

    // Validar sesión cada 30 segundos
    const validationInterval = setInterval(async () => {
      try {
        const isValid = await authService.validateSession();

        if (!isValid) {
          // Sesión fue cerrada desde otro dispositivo
          console.warn("[Session] Sesión cerrada desde otro dispositivo");

          // Notificar usuario
          alert(
            `⚠️ Tu sesión ha sido cerrada.\n\nSe ha abierto una nueva sesión desde otro dispositivo (${sessionStorage.getItem("device_name") || "desconocido"}).\n\nPor motivos de seguridad, solo puedes tener una sesión activa.`,
          );

          // Limpiar y redirigir a login
          await authService.logout();
          navigate("/login");
        }
      } catch (error) {
        console.error("[Session] Error validando sesión:", error);
      }
    }, 30000); // 30 segundos

    return () => clearInterval(validationInterval);
  }, [navigate]);
};

export default useSessionValidator;
